import { useMortgageRatesQuery } from "web_myplann/Api/Calculators/useMortgageRatesQuery";
import { OWN_HOME_RENT_FALLBACK } from "web_myplann/Inspiration/constants";
import type { MortgageRateBand } from "web_myplann/Inspiration/Types/MortgageRateBand";
import {
	OWN_HOME_LTV_PERCENT,
	OWN_HOME_MORTGAGE_MONTHS,
} from "web_myplann/Inspiration/Utils/ownHomeMath";
import { resolveOwnHomeRateBand } from "web_myplann/Inspiration/Utils/resolveOwnHomeRateBand";

type Args = {
	rent?: number;
};

type Result = {
	rates: MortgageRateBand | null;
	isLoading: boolean;
};

export const useOwnHomeRateBand = ({ rent }: Args): Result => {
	const { data, isLoading } = useMortgageRatesQuery();

	const rates = data
		? resolveOwnHomeRateBand(data, {
				monthlyPayment: rent && rent > 0 ? rent : OWN_HOME_RENT_FALLBACK,
				months: OWN_HOME_MORTGAGE_MONTHS,
				ltvPercent: OWN_HOME_LTV_PERCENT,
			})
		: null;

	return { rates, isLoading };
};
